import { Box, Flex, Button, Text, Image, useStyleConfig } from '@chakra-ui/react';
import Label from './BulletButton/Label';
import * as handlers from './handlers';
import { RiAddCircleLine } from 'react-icons/ri';
import { addFreeFormBullet } from './utils';
import { handleRegenDirect } from './Modal/utils';

const Unselected = ({ props, jobSeekerData, classes }) => {
  /*definitions*/
  const stateProps = props.stateProps;
  const unselectedBullets = stateProps.bulletData.unselectedBullets;
  const bulletGroup = stateProps.bulletData.bulletGroup;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const aiImgSrc = stateProps.domain + '/app/images/ai.png';
  /*/definitions*/

  if (typeof unselectedBullets === 'undefined' || typeof unselectedBullets[bulletGroup] === 'undefined') {
    const message = 'There are no bullets matching this group.';
    let additional_message = '';
    if (bulletGroup === 'searched') {
      additional_message = 'Try searching by keyword.';
    }
    return (
      <Box>
        <Text>{message}</Text>
        <Text>{additional_message}</Text>
      </Box>
    );
  } else {
    let ffButton = '';
    if (bulletGroup === 'freeform') {
      ffButton = <Button sx={{...buttonStyles.bulletTagActive}} onClick={e => {
        addFreeFormBullet(stateProps);
      }}>Add Bullet</Button>;
    }
    if (unselectedBullets[bulletGroup] === null) {
      return null;
    } else {
      return (
        <>
          {unselectedBullets[bulletGroup].map(
            (option, bulletIndex) => {
              let regen = true;
              let sxClasses = { ...classes.unselectedItem };
              if (option.key.includes('_r') || bulletGroup === 'searched' || bulletGroup === 'generic' || bulletGroup === 'existing' || bulletGroup === 'recommended') {
                regen = false;
              }
              if (option.key.includes('_r')) {
                sxClasses = { ...classes.unselectedItem, ...classes.unselectedRegen };
              }
              return (
                <>
                  <Box sx={sxClasses}>
                    <Flex sx={{ flexDirection: 'row' }}>
                      <Box sx={{ ...classes.unselectedLabelBox }}>
                        <Label option={option} props={props} jobSeekerData={jobSeekerData} />
                      </Box>
                      <Box position="relative" minHeight="75px">
                        <Button
                          sx={{...buttonStyles.addDel }}
                          onClick={e => {
                            handlers.select(jobSeekerData, option, stateProps);
                          }}
                        >
                          <RiAddCircleLine />
                        </Button>
                        {regen &&
                          <Button
                            sx={{...buttonStyles.addDel }}
                            position="absolute"
                            bottom=".5rem"
                            right="0"
                            onClick={e => {
                              handleRegenDirect(props, bulletGroup, bulletIndex);
                            }}>
                            <Image src={aiImgSrc} alt="AI" width="24px" height="auto" />
                          </Button>
                        }
                      </Box>
                    </Flex>
                  </Box>
                </>
              );
            },
          )}

          {ffButton}
        </>
      );
    }
  }
};

export default Unselected;
